<!--基础课门店设置-->
<template>
  <div class="root-container" style="height: 600px;">

    <el-card style="width: 100%" shadow="never">
      <el-row>
        <!--<el-col :span="3">{{ tableTitleData.swTeacher }}</el-col>-->
        <div v-for="(item,index) in tableTitleData.time" v-bind:key="index" >
          <el-col :span="3" style="text-align: center">{{item}}</el-col>
        </div>
      </el-row>
    </el-card>

    <el-card  :key="refreshTimer"  style="width: 100%" shadow="never">
      <div  v-for="(item,index) in tableData">
        <el-row style="margin-top: 0px;height: 30px" >
          <div v-for="(rest,checkIndex) in item.rests">
            <el-col :span="3" >
              <el-row >
                <div v-if="rest" >
                  <el-button type="success" size="mini"  circle @click = "checkClick(index,checkIndex)">休</el-button>
                </div>
                <div v-else >
                  <el-button  circle size="mini" @click = "checkClick(index,checkIndex)">班</el-button>
                </div>
                <!--<div>{{cn[1]}}</div>-->
              </el-row>
            </el-col>
          </div>
        </el-row>
        <el-divider></el-divider>
      </div>
    </el-card>


  </div>
</template>

<style>

</style>

<script>

  export default {
    name: 'SchelingStoreSetting',
    props: {
       rests:Array
    },
    data() {
      return {
        tableTitleData:{
          swTeacher:"休息时间",
          time:['周一','周二','周三','周四','周五','周六','周日'],
        },
        tableData:[],
        refreshTimer:null,
      }
    },
    created(){
      this.initData();
    },
    methods: {
      initData(){
        this.resetTimesSche([1])
        this.refreshData(this.rests)

      },
      //重置所有人排班
      resetTimesSche(times){
        //先将所有的都置为没有排班
        this.tableData = [];
        for (let i = 0;i< times.length;++i){
          let ld = {
            time :times[i],
            rests:[false,false,false,false,false,false,false]
          }
          this.tableData.push(ld);
        }
      },
      refreshData(rests){
        let restsObj = JSON.parse(rests)

        this.tableData[0].rests = restsObj;
      },

      checkClick(index,checkIndex){
        let check  = this.tableData[index].rests[checkIndex];
        this.tableData[index].rests[checkIndex] = (!check);
        this.refreshTimer = new Date().getTime();
      },
      onGetBaseRests(){
        return this.tableData[0].rests;
      }
    }
  }
</script>






// WEBPACK FOOTER //
// src/views/my-store/sw-teacher-scheduling-bs/components/SchelingStoreSetting.vue